<template>
<div class="modalContents__object06" data-modalContents="signup04">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
                <h2 class="text-center">MEMBERSHIP INFO.</h2>
                <form id="signup04_form" class="row no-gutters"  @submit.prevent="send">
                    
                    <h3 class="col-12">■ プラン内容（登録内容のご変更をご確認ください）</h3>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-3">視聴プラン</dt>
                        <dd class="col-9" id="signup_confirm_plan">{{ dispPlan() }}</dd>
                        <dt class="col-3" v-if="mailmagazine_change">メールマガジン</dt>
                        <dd class="col-9" id="signup_confirm_mm01" v-if="mailmagazine_change">「ニッポンの問題点」を購読{{ $store.state.inputData.mm01 ? 'する' : 'しない' }}</dd>
                        <dt class="col-3" v-if="mailmagazine_change">メールマガジン</dt>
                        <dd class="col-9" id="signup_confirm_mm02" v-if="mailmagazine_change">「読むオプエド」を購読{{ $store.state.inputData.mm02 ? 'する' : 'しない' }}</dd>
                    </dl>
 
                    <div class="col-12" id="signup_confirm_credit" v-if="$store.state.inputData.payment_type == 'credit'">
                        <div class="row no-gutters">
                            <h3 class="col-12">■ お支払い方法（登録内容をご確認ください）</h3>
                            <dl class="col-12 row no-gutters">
                                <dt class="col-3">決済方法</dt>
                                <dd class="col-9">PAY.jp 定期課金</dd>
                                <!-- 消費税込みの金額が表示されるようにしてください -->
                                <dt class="col-3">ご請求額(税込)</dt>
                                <dd class="col-9" id="signup_confirm_credit_price">{{ dispCreditPrice() }}円</dd>
                            </dl>
                            <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                                <button class="text-center btn modalContents__object06--change globalModal--btn"
                                    data-modal="signupChange03" type="submit">修正</button>
                            </div> -->
                        </div>
                    </div>

                    <!-- 銀行支払いの場合 -->
                    <div class="col-12" id="signup_confirm_bank" v-if="$store.state.inputData.payment_type == 'bank'">
                        <div class="row no-gutters">
                            <h3 class="col-12">■ お支払い方法（登録内容をご確認ください）</h3>
                            <dl class="col-12 row no-gutters">
                                <dt class="col-3">決済方法</dt>
                                <dd class="col-9">銀行振込</dd>
                                <dt class="col-3">振込名義人</dt>
                                <dd class="col-9" id="signup_confirm_bank_name">{{ $store.state.inputData.bank_name }}</dd>
                                <dt class="col-3">ご契約期間</dt>
                                <dd class="col-9" id="signup_confirm_bank_month">{{ $store.state.inputData.bank_month }}ヵ月</dd>
                                <!-- 消費税込みの金額が表示されるようにしてください -->
                                <dt class="col-3">ご請求額(税込)</dt>
                                <dd class="col-9" id="signup_confirm_bank_price">{{ dispBankPrice() }}円</dd>
                            </dl>
                            <!-- <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                                <button class="text-center btn modalContents__object06--change globalModal--btn"
                                    data-modal="signupChange03" type="submit">修正</button>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-12">
                        <button id="signup_submit" class="text-center btn modalContents__object06--submit globalModal--btn"
                            data-modal="signupSubmit" type="submit">プランを変更する</button>
                    </div>

                    <ul class="col-12 row no-gutters">
                        <li class="col-12"><strong>表示金額は税込の金額</strong>になります。</li>
                        <li class="col-12">カード決済を選択された場合、毎月1日の決済となります。</li>
                        <li class="col-12">銀行振込を選択された場合、ブロンズ会員以上のお申し込みの方には、ご登録後に<strong>お振込方法などを詳しく説明したメールをお送りいたします。</strong>入金確認まではブロンズ会員として、ニューズ・オプエドをお楽しみください。</li>
                    </ul>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "MypageEditPlanConfirm",
    mixins: [MultiModalMixin],
    data : function(){
      let data = {};
      data.isLogged = OPED.isLogged;

      data.mailmagazine_change = true;

      if(data.isLogged){
        if(OPED.isLogged){
          if(!OPED.login_user.email){
            data.mailmagazine_change = false;
          }
        }
      }
      return data;
    },
    methods : {
      // $store.state.inputData.birthday
      dispPlan(){
        let plan = this.$store.state.inputData.plan;
        switch (plan) {
          case 'bronze':
              return "ブロンズメンバー";
          case 'silver':
              return "シルバーメンバー";
          case 'gold':
              return "ゴールドメンバー";
          case 'platinum':
              return "プラチナメンバー（サロン）";
        }
      },
      dispCreditPrice(){
        let plan = this.$store.state.inputData.plan;
        let mm01 = this.$store.state.inputData.mm01;
        let mm02 = this.$store.state.inputData.mm02;
        return getPlanPrice(plan,mm01,mm02,1);
      },
      dispBankPrice(){
        let plan = this.$store.state.inputData.plan;
        let mm01 = this.$store.state.inputData.mm01;
        let mm02 = this.$store.state.inputData.mm02;
        let month = this.$store.state.inputData.bank_month;
        return getPlanPrice(plan,mm01,mm02,month);
      },

      send(){
        if(this.isLogged){
          let params = {};
          params.plan = this.$store.state.inputData.plan;
          params.mm01 = this.$store.state.inputData.mm01 ? true : false;
          params.mm02 = this.$store.state.inputData.mm02 ? true : false;
          params.payment = this.$store.state.inputData.payment_type;
          if(this.$store.state.inputData.payment_type == 'credit'){
            params.payment_token = this.$store.state.inputData.payment_token;
          }
          if(this.$store.state.inputData.payment_type == 'bank'){
            params.bankname = this.$store.state.inputData.bank_name;
            params.bankmonth = this.$store.state.inputData.bank_month;
          }
          $('#signup_submit').fadeOut(300);
          axios
            .post('/auth/change-plan',params)
            .then(response => {
              //if(response.status == 200){
                this.showModalEditPlanThanks();
              //}
            })
            .catch(error => {
              
            })
        }
      },
    },
    watch : {
      
    },
    mounted () {
      //console.log(this.$store.state.inputData.mm01);
    }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/mypage_edit_plan_confirm.vue